import { render } from "./TelaProdutos.vue?vue&type=template&id=0da560e3&scoped=true"
import script from "./TelaProdutos.vue?vue&type=script&lang=js"
export * from "./TelaProdutos.vue?vue&type=script&lang=js"

import "./TelaProdutos.vue?vue&type=style&index=0&id=0da560e3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da560e3"]])

export default __exports__